import EditPasswordAccountModalView from "./editPasswordModal.html";
import TryConnectionModalView from "./tryConnectionModal.html";

angular.module("mail_accounts")

    .controller("MailAccountsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MAIL_ACCOUNTS_WRITE");

            $rootScope.title = $filter('translate')('mail_accounts.title');

            $scope.isCorrectReplyTo = true;

            $scope.tinymceOptions = {
                resize: true,
                forced_root_block: false,
                contextmenu: false,
                branding: false,
                relative_urls: false,
                convert_urls: false,
                remove_script_host: false,

                height: 60,
                body_class: 'custom_tinymce_content',
                //valid_classes: 'razor_expression',
                language: 'es',
                paste_as_text: true,
                plugins: 'paste autoresize textcolor image lists advlist table noneditable code link',
                toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link | table | image | code",
                menubar: false,
                statusbar: false,
                setup: function (editor) {

                }
            };

            $scope.mail_account = {
                use_for_system_mails: true,
                replyto_list_array: []
            };

            $scope.mailAccountTypes = [];

            $scope.editingPassword = false;
            $scope.startEditPassword = function () {
                $scope.editingPassword = true;
                $scope.mail_account.update_password = true;
            };

            $scope.isSMTP = function () { return $scope.mail_account.mail_account_type_id == 1; };
            $scope.isSendGrid = function () { return $scope.mail_account.mail_account_type_id == 2; };
            $scope.isMicrosoft365 = function () { return $scope.mail_account.mail_account_type_id == 3; };
            $scope.isExchange = function () { return $scope.mail_account.mail_account_type_id == 4; };

            function hasTypeSpecificData() {
                return !!(
                    $scope.mail_account.server ||
                    $scope.mail_account.port ||
                    $scope.mail_account.username ||
                    $scope.mail_account.password ||
                    $scope.mail_account.ms_tenant_id ||
                    $scope.mail_account.ms_client_id
                );
            }

            function applyTypeChange(typeId) {
                $scope.mail_account.mail_account_type_id = typeId;
                $scope.mail_account.server = null;
                $scope.mail_account.port = null;
                $scope.mail_account.username = null;
                $scope.mail_account.password = null;
                $scope.mail_account.ms_tenant_id = null;
                $scope.mail_account.ms_client_id = null;
                $scope.editingPassword = false;
            }

            $scope.changeType = function (typeId) {
                if ($scope.mail_account.mail_account_type_id == typeId) return;
                if (hasTypeSpecificData()) {
                    modalService.confirm({
                        title: $filter('translate')('mail_accounts.type_change_title'),
                        message: $filter('translate')('mail_accounts.type_change_warning'),
                        onAccept: function () { applyTypeChange(typeId); }
                    });
                } else {
                    applyTypeChange(typeId);
                }
            };

            // Load types
            Restangular.all('MailAccountTypes').getList().then(function (types) {
                $scope.mailAccountTypes = types;
            });

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('mail_accounts.title'), url: "mail_accounts.list" },
                    { title: $filter('translate')('mail_accounts.title_add') },
                ];

                $scope.mail_account.mail_account_type_id = 1;

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('mail_accounts.title'), url: "mail_accounts.list" },
                    { title: $filter('translate')('mail_accounts.title_edit') },
                ];

                Restangular.one('MailAccounts', $stateParams.id).get().then(function (result) {
                    $scope.mail_account = result;
                    if ($scope.mail_account.reply_to!=null) {
                        $scope.mail_account.replyto_list_array = $scope.mail_account.reply_to.split(",");
                    } else {
                        $scope.mail_account.replyto_list_array = [];
                    }
                });
            }

            $scope.saveMailAccount = function () {

                if ($scope.mail_account.replyto_list_array.length > 1) {
                    $scope.isCorrectReplyTo = false;
                } else {
                    $scope.isCorrectReplyTo = true;

                    $scope.mail_account.reply_to = $scope.mail_account.replyto_list_array.join(",");

                    if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                        $scope.mail_account.put().then(function (result) {
                            if (angular.isDefined(result.id)) {
                                toastr.success($filter('translate')('mail_accounts.save_success'));
                                $state.go("mail_accounts.list");
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    } else {
                        Restangular.all('MailAccounts').post($scope.mail_account).then(function (result) {
                            if (angular.isDefined(result.id)) {
                                toastr.success($filter('translate')('mail_accounts.edit_success'));
                                $state.go("mail_accounts.list");
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('mail_accounts.button_delete'),
                    message: $filter('translate')('mail_accounts.delete_message') + " " + $scope.mail_account.name + "?",
                    onAccept: function () {
                        $scope.mail_account.remove().then(function () {
                            toastr.success($filter('translate')('mail_accounts.deleted_success'));
                            $state.go("mail_accounts.list");
                        });
                    }
                });
            };

            $scope.tryConnection = function () {
               $scope.$modalInstancee = $uibModal.open({
                    animation: true,
                    template: TryConnectionModalView,
                    controller: "TryConnectionModalCtrl",
                    resolve: {
                        entity: function () {
                            return $scope.mail_account;
                        }
                    }
                });
            }
        }])

.controller("EditPasswordAccountModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'entity', 'modalService', '$filter', function ($scope, $uibModalInstance, Restangular, entity, modalService, $filter) {
    let tests = [/[a-z]/i];

    function test(pass) {
        if (pass == null)
            return -1;
        let s = 0;
        if (pass.length < 4)
            return 0;
        for (let i in tests)
                s++
        return s;
    }

    $scope.password = "";
    $scope.validPassword = false;

    $scope.v = function () {
        let val = test($scope.password);
        $scope.validPassword = val ===1;
        return val;
    };


    $scope.entity = entity;

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.savePassword = function () {
        if ($scope.password != "") {
            $scope.entity.password = $scope.password;
            $scope.entity.update_password = true;
            $scope.entity.put().then(function (result) {
                if (angular.isDefined(result.id)) {
                    $scope.entity.password = result.password;
                    $scope.entity.update_password = false;
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('users.password_updated'));
                }
            });
        }
    };
}])

.controller("TryConnectionModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'entity', 'LoginService', '$filter', function ($scope, $uibModalInstance, Restangular, entity, LoginService, $filter) {

    $scope.entity = entity;
    $scope.mailTo = '';
    $scope.userMail = '';
    $scope.message = null;
    $scope.success = null;
    $scope.sending = false;

    Restangular.one('Users/Mail', LoginService.get("userId")).get().then(function (mail) {
        $scope.userMail = mail;
        $scope.mailTo = mail;
    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.sendEmail = function () {
        $scope.sending = true;
        $scope.message = null;

        Restangular.all('MailAccounts').customPOST({ id: $scope.entity.id, email: $scope.mailTo }, "TryMailConnectionViaNotification").then(function () {
            $scope.sending = false;
            $scope.success = true;
            $scope.message = $filter('translate')('mail_accounts.test_notification_queued');
        }, function () {
            $scope.sending = false;
            $scope.success = false;
            $scope.message = $filter('translate')('mail_accounts.test_send_error');
        });
    };
}]);


